export const TID = {
  nav: {
    root: "nav-root",
    logo: "nav-logo",
    services: "nav-services",
    cities: "nav-cities",
    about: "nav-about",
    journal: "nav-journal",
    quote: "nav-quote-cta",
    mobileToggle: "nav-mobile-toggle",
  },
  hero: {
    root: "hero-root",
    line: "hero-line",
    cta: "hero-cta",
  },
  services: {
    root: "services-grid",
    card: "service-card",
    detail: "service-detail",
  },
  cities: {
    root: "cities-list",
    item: "city-item",
    detail: "city-detail",
  },
  quote: {
    form: "quote-form",
    name: "quote-name",
    company: "quote-company",
    city: "quote-city",
    service: "quote-service",
    date: "quote-start-date",
    site: "quote-site-type",
    guards: "quote-guards",
    duration: "quote-duration",
    message: "quote-message",
    submit: "quote-submit",
    success: "quote-success",
  },
  footer: {
    root: "footer-root",
  },
};
